import React from 'react';
import { Activity, DollarSign, Mic, Target, User } from 'lucide-react';
import { useAppContext } from '../context/AppContext';

export default function BottomNav() {
  const { activeTab, setActiveTab } = useAppContext();

  const tabs = [
    { id: 'dashboard',  icon: <Activity size={22} />,   label: 'Dashboard' },
    { id: 'commission', icon: <DollarSign size={22} />,  label: 'Earnings'  },
    { id: 'leads',      icon: <Target size={22} />,      label: 'Leads'     },
    { id: 'memos',      icon: <Mic size={22} />,         label: 'Memos'     },
    { id: 'profile',    icon: <User size={22} />,        label: 'My Profile'},
  ];

  return (
    <nav className="bottom-nav">
      {tabs.map(({ id, icon, label }) => (
        <button
          key={id}
          className={`nav-btn ${activeTab === id ? 'nav-active' : ''}`}
          onClick={() => setActiveTab(id)}
        >
          {icon}<span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
